import React from 'react'
import { useState } from 'react'
import { Box, Collapse, Flex, Icon, Text, Link } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import Pdf from '../../theme/icons/Pdf'
import EFL3DsMax from '../../theme/icons/EFL3DsMax'
import Dwg from '../../theme/icons/Dwg'
import Dxf from '../../theme/icons/Dxf'

function AccordionList({ t, i18n, showCard }) {
  const [openSection, setOpenSection] = useState(null)
  const trackAccordionClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'accordion_click',
      event_category: 'Button',
      event_label: 'Accordion btn',
      // accordion_section: key, // optional extra info
    });
  };
  const sections = [
    {
      key: 'manuals',
      label: 'techTitles.4',
      content: (lang, showCardItem) => (
        <Link
          target="_blank"
          href={
            lang === 'en' ? showCardItem?.manuals?.englishPdf : showCardItem?.manuals?.russianPdf
          }
        >
          <Pdf fontSize="60px" color="white" />
        </Link>
      ),
    },
    {
      key: 'install',
      label: 'techTitles.2',
      content: (lang, showCardItem) => (
        <Link
          target="_blank"
          href={
            lang === 'en'
              ? showCardItem?.installation?.englishPdf
              : showCardItem?.installation?.russianPdf
          }
        >
          <Pdf fontSize="60px" color="white" />
        </Link>
      ),
    },
    {
      key: 'cad',
      label: `${showCard?.translate}.11`,
      content: (_lang, showCardItem) => (
        <>
          <Box>
            <Link href={showCardItem?.cad?.smaxZip} download>
              <EFL3DsMax color="white" fontSize="60px" />
            </Link>
          </Box>
          <Box mx="25px">
            <Link href={showCardItem?.cad?.dwg} download>
              <Dwg color="white" fontSize="60px" />
            </Link>
          </Box>
          <Box>
            <Link href={showCardItem?.cad?.dxf} download>
              <Dxf color="white" fontSize="60px" />
            </Link>
          </Box>
        </>
      ),
    },
  ]
  return sections.map(({ key, label, content }) => {
    const isOpen = openSection === key
    return (
      <Box
        key={key}
        borderBottomWidth="1px"
        // pb="30px"
        height={{ sm: isOpen ? '120px' : '42px', md: isOpen ? '140px' : '50px' }}
        transition="all 0.2s ease-in-out"
      >
        <Flex
          width="full"
          justifyContent="space-between"
          alignItems="center"
          cursor="pointer"
          my={2}
          onClick={() => {
            trackAccordionClick();
            setOpenSection(isOpen ? null : key);
          }}
        >
          <Text fontSize={{ base: 'md', md: '2xl' }} px={{ base: 4, md: 0 }}>
            {t(label)}
          </Text>
          <Icon
            as={ChevronDownIcon}
            transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
            transition="transform 0.2s"
            boxSize={6}
            mr={2}
          />
        </Flex>
        <Collapse in={isOpen} animateOpacity>
          <Flex p="10px 5px" >
            {content(i18n.language, showCard)}
          </Flex>
        </Collapse>
      </Box>
    )
  })
}

export default AccordionList
